import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import '../assets/table.css';
import Papa from 'papaparse'
import { Fragment, useEffect, useState } from 'react';
import WinnerChart from '../components/Chart';
import Logos from '../components/Logos';
import Fade from 'react-reveal/Fade';

const Scoreboard = () => {

	const [data, setData] = useState([]);
	const [negative, setNegative] = useState([]);
	const [series, setSeries] = useState([
		{
			name: "score",
			data: [],
		},
	]);

	useEffect(() => {
		Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vS8f5ggUHIS_Zmp76yoAf65QGf8tZfZGEuVjDOhxk_jwNtXAHd8eNLtkc0k49oJYeWpEiot0rH8ypVf/pub?gid=0&single=true&output=csv", {
			download: true,
			header: true,
			dynamicTyping: true,
			skipEmptyLines: true,
			complete: function (results) {
				setData(results.data)
			},
		})
		fetchNegative();
	}, []);

	useEffect(() => {
		try {
			setSeries({
				name: "score",
				data: [
					data[3].Aryans + negative[0].Aryans,
					data[3].Mughals + negative[0].Mughals,
					data[3].Rajputs + negative[0].Rajputs,
					data[3].Spartans + negative[0].Spartans,
					data[3].Vikings + negative[0].Vikings,
				]
			})
		} catch (e) {
			console.log(e)
		}
	}, [data, negative]);

	const fetchNegative = async () => {
		const response = await fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vRGWEbGObsouRjf9v4v9whxghIh6MLmk3XsKP3-mtwzsr2kduGkkokruqckzffXMSu0UuGzHSdHZhbf/pub?gid=0&single=true&output=csv");
		const textData = await response.text();
		return setNegative(Papa.parse(textData, { header: true, skipEmptyLines: true, dynamicTyping: true }).data);
	}

	return (
		<div className="pb-14 border-b">
			<div className="m-6 my-20 md:mx-16 md:mb-28">
				<Fade><h2 className="text-4xl font-bold text-center py-6 md:text-6xl md:pt-12">Scoreboard</h2></Fade>

				{/* <WinnerChart /> */}
				<Fade bottom>
					<div className="flex justify-center">
						<WinnerChart series={series} />
					</div>
				</Fade>

				<Fade><h3 className="text-3xl font-bold mt-14 mb-10 text-center">Leaderboard</h3></Fade>

				<Fade bottom>
					<div className="mt-12">
						<Table className="border -z-10">
							<Thead className="text-center md:border-2">
								<Tr className="text-2xl font-bold border">
									<Th className="p-4">Event</Th>
									<Th>1<sup>st</sup></Th>
									<Th>2<sup>nd</sup></Th>
									<Th>3<sup>rd</sup></Th>
								</Tr>
							</Thead>
							<Tbody className="text-center">
								{
									data.slice(4).map((row) => {
										return (
											<Tr className="border" style={{ border: "1px solid #fff" }}>
												<Td className="p-4 border-x font-bold">{row.Event}</Td>
												<Td className="p-4 border-x">{row.First}<i>{row.FirstHouse}</i></Td>
												<Td className="p-4 border-x">{row.Second}<i>{row.SecondHouse}</i></Td>
												<Td className="p-4 border-x">{row.Third}<i>{row.ThirdHouse}</i></Td>
											</Tr>
										);
									})
								}
							</Tbody>
						</Table>
					</div>
				</Fade>

				<Fade><h3 className="text-3xl font-bold mt-14 mb-10 text-center">Negative Marks</h3></Fade>

				<Fade bottom>
					<div className="grid grid-cols-3 text-center">
						<div className="border-y border-l text-xl font-bold px-2 py-4 md:p-4 md:border-y-2 md:border-l-2">House</div>
						<div className="border-y text-xl font-bold px-2 py-4 md:p-4 md:border-y-2">Score</div>
						<div className="border-y border-r text-xl font-bold px-2 py-4 md:p-4 md:border-y-2 md:border-r-2">Remark</div>
						{negative.slice(1).map((row) => {
							return (
								<Fragment>
									<div className="border inline-flex justify-center items-center p-2 md:p-4">{row.House}</div>
									<div className="border inline-flex justify-center items-center p-2 md:p-4">{row.Score}</div>
									<div className="border inline-flex justify-center items-center p-2 md:p-4">{row.Remark}</div>
								</Fragment>
							)
						})}
					</div>
				</Fade>

				<Fade><h3 className="text-3xl font-bold mt-14 mb-10 text-center">Additional Marks</h3></Fade>

				<Fade bottom>
					<div className="grid grid-cols-3 text-center">
						<div className="border-y border-l text-xl font-bold px-2 py-4 md:p-4 md:border-y-2 md:border-l-2">House</div>
						<div className="border-y text-xl font-bold px-2 py-4 md:p-4 md:border-y-2">Score</div>
						<div className="border-y border-r text-xl font-bold px-2 py-4 md:p-4 md:border-y-2 md:border-r-2">Remark</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Mughals</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">20</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Deco - Fourth</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Rajputs</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">10</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Deco - Fifth</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Mughals</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">20</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Feel of Bharatham - Fourth</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Aryans</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">10</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Feel of Bharatham - Fifth</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Spartans</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">20</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Prop Dance - Fourth</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Rajputs</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">10</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Prop Dance - Fifth</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Rajputs</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">20</div>
							<div className="border inline-flex justify-center items-center p-2 md:p-4">Thematic Dance - Fourth</div>
					</div>
				</Fade>
			</div>

			<Fade><Logos /></Fade>
		</div>
	);
}

export default Scoreboard;